export default "__VITE_ASSET__CwwtoXHk__"